module.exports = __webpack_public_path__ + "static/media/questionMarkNeon.06c3e260.svg";